const DEFAULT_MINIMUM_PHONE_DIGITS = 9
const MAXIMUM_PHONE_DIGITS = 20

// Local numbers in these countries are 8 digits, so the default minimum rejects valid entries.
const MINIMUM_PHONE_DIGITS_BY_COUNTRY = {
    SG: 8,
    QA: 8,
    AE: 8
}

export function minimumPhoneDigits (countryCode) {
    return MINIMUM_PHONE_DIGITS_BY_COUNTRY[countryCode] || DEFAULT_MINIMUM_PHONE_DIGITS
}

// Counts digits rather than looking for an unbroken run, so numbers typed with spaces, brackets
// or a +country prefix are accepted. The API formats them with libphonenumber before sending SMS.
export function isValidPhoneNumber (phone, countryCode) {
    const digitCount = String(phone).replace(/\D/g, '').length
    return digitCount >= minimumPhoneDigits(countryCode) && digitCount <= MAXIMUM_PHONE_DIGITS
}

export function phoneNumberTooShortMessage (countryCode) {
    return `The phone number must be a minimum of ${minimumPhoneDigits(countryCode)} digits`
}
